import { render, staticRenderFns } from "./ReStaffNotifyConf.vue?vue&type=template&id=fe253a8a&scoped=true"
import script from "./ReStaffNotifyConf.vue?vue&type=script&lang=js"
export * from "./ReStaffNotifyConf.vue?vue&type=script&lang=js"
import style0 from "./ReStaffNotifyConf.vue?vue&type=style&index=0&id=fe253a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe253a8a",
  null
  
)

export default component.exports